import { render, staticRenderFns } from "./resulting.vue?vue&type=template&id=5931b2d4&"
import script from "./resulting.vue?vue&type=script&lang=js&"
export * from "./resulting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports